module.exports = __webpack_public_path__ + "img/taochi2.5ed4c13d.jpg";